import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_hybrid")({
  component: RouteComponent,
  ssr: true,
});

function RouteComponent() {
  return <Outlet />;
}
